import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { NavBarModule } from '@shared/core/components/navBar';
import { FiltersDrawModule } from '@shared/core/components/filtersDraw';
import { HeroBackgroundModule } from '@shared/core/components/heroBackground';
import { MainDrawModule } from '@shared/core/components/mainDraw';
import { SubDrawModule } from '@shared/core/components/subDraw';
import { FooterModule } from '@shared/core/components/footer';

import { ScaffoldForRegularComponent } from './scaffold-for-regular.shared.component';

@NgModule({
    declarations: [
        ScaffoldForRegularComponent
    ],
    imports: [
        CommonModule,
        NavBarModule,
        FiltersDrawModule,
        HeroBackgroundModule,
        MainDrawModule,
        SubDrawModule,
        FooterModule,
    ],
    exports: [
        ScaffoldForRegularComponent
    ],
})
export class ScaffoldForRegularModule { }
